import React from 'react';
import PropTypes from 'prop-types';
import {DeliveryOption} from './CheckoutPage.style';

const RenderRadioButton = ({input, type, id, isDisabled, callback}) => (
  <DeliveryOption
    {...input}
    id={id}
    type={type}
    disabled={isDisabled}
    onClick={callback}
  />
);

RenderRadioButton.propTypes = {
  input: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  callback: PropTypes.func,
  isDisabled: PropTypes.bool
};

export default RenderRadioButton;



// WEBPACK FOOTER //
// ./containers/CheckoutPage/RenderRadioButton.js